










































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import EnterNubiiAnimation from "@/resources/mixins/animations/enterNubiiAnimation";
import { WELCOME_IMAGES } from "@/resources/constants/exitImages";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { MANAGE_SPACE_OPTIONS } from "@/resources/constants/sidebarMenu";
import { i18n } from "@/resources/locales";
import GraphicClient from "@/resources/mixins/graphicClient/graphicClient";
import {
  MessageType,
  UserSendMessageType,
} from "@/resources/constants/graphicClient/graphicClient";
import { isAudioTransformDevice } from "amazon-chime-sdk-js";
import Plans from "@/resources/mixins/plans/plans";
import UserValidator from "@/resources/mixins/userValidator";
@Component({
  name: "good-morning-component",
})
export default class GoodMorningModalComponent extends mixins(
  EnterNubiiAnimation,
  NotificationEvent,
  UserValidator,
  Plans
) {
  showImage = null;
  mounted(): void {
    const index = Math.floor(Math.random() * WELCOME_IMAGES.length);
    this.showImage = WELCOME_IMAGES[index];
  }
  get active(): boolean {
    return this.$store.getters["SystemStore/getShowGoodMorningModal"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setShowGoodMorningModalAction", false);
  }
  get space(): SpaceInterface {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  showInvitation(): boolean {
    const space = this.space;
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    return space.createdBy.id === spaceUser.superSpaceUser.user.id;
  }
  onClose(): void {
    this.setGrazing();
    this.$store.dispatch("SystemStore/setShowGoodMorningModalAction", false);
    if (this.space.isAssassinGameActivated) {
      this.$store.dispatch("SystemStore/setGameKillerInfoModalAction", true);
      //this.$store.dispatch("SystemStore/setGameKillerModalAction", true);
    }
    const showNotification =
      localStorage.getItem("show_notification_invitation") === "true";
    let wall = localStorage.getItem("isWall")
      ? localStorage.getItem("isWall") === "true"
      : false;
    if (wall) {
      localStorage.setItem("isWall", wall.toString());
      this.$store.dispatch("GraphicClientStore/wallsUpdateAction", wall);
    }
    if (this.showInvitation() && !showNotification) {
      localStorage.setItem("show_notification_invitation", "true");
      setTimeout(() => {
        const openMenu = document.getElementById("openMenu");
        const copyUrl = document.getElementById("copyUrl");
        openMenu.addEventListener("click", () => {
          this.openMenuInvitation();
        });
        copyUrl.addEventListener("click", () => {
          this.copy();
        });
      }, 1000);
    }

    this.activeEnterEffect();
    if (/*(this.isAdmin() || this.isSuperSpaceOwner()) &&*/ this.getPlan() == "FREE" || this.getPlan() == "DEMO") {
      this.$store.dispatch("SystemStore/setShowModalPlanWarningPremiumAction", true);
    }
  }
  convertUrlToLink(text: string): string {
    /* if (this.isHtml(text)) return text.toString();*/
    // URLs starting with http://, https://, or ftp://
    const replacePattern1 =
      /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/gim;
    let replacedText = text.replace(
      replacePattern1,
      '<a href="$1" target="_blank">$1</a>'
    );

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    const replacePattern2 = /(^|[^\\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(
      replacePattern2,
      '<a href="http://$2" target="_blank">$2</a>'
    );

    // Change email addresses to mailto:: links.
    const replacePattern3 =
      /(([a-zA-Z0-9\-\\_\\.])+@[a-zA-Z\\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(
      replacePattern3,
      '<a href="mailto:$1">$1</a>'
    );
    const div = document.createElement("p");
    div.innerHTML = replacedText;

    return replacedText;
  }
  isHtml(text: string): boolean {
    const regex = /<[^>]*>/;
    return regex.test(text);
  }
  copy(): void {
    const space = this.space;
    const url =
      window.location.origin +
      "/invitation/user/" +
      space.userInvitationToken +
      "/" +
      space.name.replaceAll(" ", "_");
    const cb = navigator.clipboard;
    cb.writeText(url).then(() =>
      this.onDefault("", this.$i18n.t("notifications.descriptions.copyUrl"))
    );
  }
  userUrl(): string {
    const space = this.space;
    const url =
      window.location.origin +
      "/invitation/user/" +
      space.userInvitationToken +
      "/" +
      space.name.replaceAll(" ", "_");
    return url;
  }
  openMenuInvitation(): void {
    this.$store.dispatch("FloatMenuStore/setManageSpaceAction", true);
    this.$store.dispatch(
      "SystemStore/setManageSpaceMenuActiveAction",
      MANAGE_SPACE_OPTIONS.INVITE
    );
    this.$store.dispatch("SystemStore/setShowGoodMorningModalAction", false);
  }
  setGrazing(): void {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    const alwaysGrazing = localStorage.getItem("alwaysGrazing");
    const room = localStorage.getItem("room");
    if (
      (room &&
        !spaceUser.superSpaceUser.user.isFirstTime &&
        spaceUser.isFirstTime) ||
      (room && alwaysGrazing == "true")
    ) {
      this.$store.dispatch("SpaceStore/getRoomGrazingAction", {
        roomId: room,
        callback: (response) => {
          GraphicClient.sendMessage(
            MessageType.USER,
            UserSendMessageType.MOVE_LOCAL_USER,
            {
              graphicClientRoomId: response.graphicClientRoomId,
              id: response.id,
            }
          );
          if (!spaceUser.superSpaceUser.user.isFirstTime) {
            localStorage.removeItem("room");
            localStorage.removeItem("alwaysGrazing");
          }
        },
        callbackError: (error) => {
          if (!spaceUser.superSpaceUser.user.isFirstTime) {
            localStorage.removeItem("room");
            localStorage.removeItem("alwaysGrazing");
          }
        },
      });
    }
  }
}
